// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MagnifyingGlassIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MagnifyingGlassIcon" ref={forwardedRef} {...props}>
      <path d="M11.525 12.855a6 6 0 1 1 1.4-1.429l3.816 3.817a1 1 0 0 1-1.415 1.414zM12.498 8a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MagnifyingGlassIcon = /* @__PURE__ */ Object.assign(
  MagnifyingGlassIconComponent,
  { displayName: 'MagnifyingGlassIcon' },
);
